import React from 'react'
import PropTypes from 'prop-types'
import ExclusionModal from 'component/Modal/ExclusionModal'
import Glyph from 'component/utils/Glyph'
import Switch from 'component/Switch'

const Table = ({
  justifications,
  translate,
  editEntry,
  updateActive,
  remove,
}) => (
  <div className='new-style new-outer-table outer-table'>
    <table cellPadding={0} cellSpacing={0} className='new-table margin-top'>
      <thead>
        <tr>
          <th>{translate('justifications.justificationDesc')}</th>
          <th className='text-align-center medium-column-width'>
            {translate('justifications.justificationActive')}
          </th>
          <th className='text-nowrap text-align-center medium-column-width'>
            {translate('justifications.justificationEdit')}
          </th>
          <th className='text-nowrap text-align-center medium-column-width'>
            {translate('justifications.justificationExclude')}
          </th>
        </tr>
      </thead>
      <tbody>
        <>
          {(justifications || []).map((entry, idx) => {
            const { dsJustification, inInactive, idJustification } = entry

            return (
              <>
                <tr key={idx}>
                  <td className='text-left'>{dsJustification}</td>
                  <td className='text-left'>
                    <Switch
                      defaultValue={!inInactive}
                      key={idJustification}
                      onChange={() =>
                        updateActive({
                          ...entry,
                          inInactive: inInactive ? 0 : 1,
                        })
                      }
                    />
                    &nbsp;&nbsp;
                    {translate(
                      inInactive
                        ? 'justificationsPa.inactive'
                        : 'justificationsPa.active'
                    )}
                  </td>
                  <td className='text-align-center'>
                    <Glyph
                      type='pencil'
                      color='primary'
                      customClass='font-20 cursor-pointer'
                      onClick={() => editEntry(entry)}
                    />
                  </td>
                  <td className='text-align-center'>
                    <ExclusionModal
                      t={translate}
                      title={translate('justifications.justificationExclude')}
                      onConfirm={() => remove(idJustification)}
                      message={
                        <>
                          <br />
                          {translate('justificationsPa.removeModal.text')}
                          <br />
                          <b> {dsJustification} </b>
                        </>
                      }
                      confirmButtonMsg='approvers.remove.confirm'
                      renderButton={({ onClick }) => (
                        <a
                          id={`view-mission-${idx}`}
                          role='button'
                          onClick={onClick}
                        >
                          <i className='font-20 color-danger glyph glyph-trash-can icon-size' />
                        </a>
                      )}
                    />
                  </td>
                </tr>
              </>
            )
          })}
        </>
      </tbody>
    </table>
  </div>
)

Table.propTypes = {
  justifications: PropTypes.array.isRequired,
  translate: PropTypes.func,
  editEntry: PropTypes.func,
  updateActive: PropTypes.func,
  remove: PropTypes.func,
}

export default Table
